"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const client_1 = require("@rws-framework/client");
const component_2 = require("@front/layouts/default-layout/component");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const AccountLimitService_1 = __importStar(require("@front/services/AccountLimitService"));
const SignalService_1 = __importStar(require("@front/services/SignalService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="avatar-list-page">
    <crud-table class="${x => x.isList ? '' : 'd-none'}" :isItemUneditable="${x => x.isAvatarUneditable}"
      :forceItemEditable="${x => x.forceAvatarEditable}" :onDataLoaded="${x => x.onDataLoaded}"
      title="${'avatar.listTitle'.t()}" addText="${'avatar.addAvatar'.t()}" resource="avatar"
      searchPlaceholder="${'avatar.searchPlaceholder'.t()}" listEndpoint="avatar.list" deleteEndpoint="avatar.delete"
      queryParam="q" :actions="${x => x.baseActions}" : editRoute="/avatar/form/:id" addRoute="/avatar/form"
      :columns="${x => x.tableColumns}">
      <div slot="extra-buttons">
        <div class="btn-group mr-2 grid-switch" role="group">
          <button @click="${x => x.toggleToList()}" class="btn btn-primary" title="${'avatar.listView'.t()}">
            <i class="simple-icon-list"></i>
          </button>
          <button @click="${x => x.toggleToGrid()}" class="btn btn-outline-primary" title="${'avatar.gridView'.t()}">
            <i class="simple-icon-grid"></i>
          </button>
        </div>
      </div>
    </crud-table>
    <div id="avatar-grid" class="${x => x.isList ? 'd-none' : ''}">
      <div class="mb-2">
        <h1>${x => x.title.t()}</h1>
        <div class="text-zero top-right-button-container">
          <div class="btn-group mr-2 grid-switch" role="group">
            <button @click="${x => x.toggleToList()}"
              class="btn ${x => x.isList ? 'btn-primary' : 'btn-outline-primary'}" title="${'avatar.listView'.t()}">
              <i class="simple-icon-list"></i>
            </button>
            <button @click="${x => x.toggleToGrid()}"
              class="btn ${x => !x.isList ? 'btn-primary' : 'btn-outline-primary'}" title="${'avatar.gridView'.t()}">
              <i class="simple-icon-grid"></i>
            </button>
          </div>
          ${(0, fast_element_1.when)(x => x.canAdd, (0, fast_element_1.html) `
            ${(0, fast_element_1.when)(x => x.limitReached, (0, fast_element_1.html) `
              <rws-tooltip text="${x => x.limitTooltip}">
                <button disabled
                  class="top-right-button mr-1 btn btn-primary btn-lg disabled">${x => x.addText ? x.addText.t() : 'crud.create'.t()}</button>
              </rws-tooltip>
            `, (0, fast_element_1.html) `
              <button @click="${(x, c) => x.navigateTo('/avatar/form')}"
                class="top-right-button mr-1 btn btn-primary btn-lg">${x => x.addText ? x.addText.t() : 'crud.create'.t()}</button>
            `)}
          `)}
        </div>
      </div>

      ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}

      ${(0, fast_element_1.when)(x => !x.loading && x.avatarData.length === 0, (0, fast_element_1.html) `
      <div class="text-center mt-5">
        <p class="text-muted">${'avatar.noAvatars'.t()}</p>
      </div>
      `)}

      ${(0, fast_element_1.when)(x => !x.loading && x.avatarData.length > 0, (0, fast_element_1.html) `
      <div class="row">
        ${(0, fast_element_1.repeat)(x => x.avatarData, (0, fast_element_1.html) `
        <div class="col-lg-4 mb-4">
          <div class="card card-body position-relative h-100">
            <div class="text-center mt-5 py-lg-2 mb-3">
              ${(0, fast_element_1.when)(avatar => avatar.logo, (0, fast_element_1.html) `
              <div class="mb-3">
                <img src="${avatar => `uploads/${avatar.logo.filename}`.thumb('square-small')}"
                  alt="${avatar => avatar.name}" class="rounded-circle" width="64" height="64"
                  style="object-fit: cover;" />
              </div>
              `, (0, fast_element_1.html) `
              <div class="mb-3">
                <img src="/assets/images/avatar.jpg" alt="${avatar => avatar.name}" class="rounded-circle" width="64"
                  height="64" style="object-fit: cover;" />
              </div>
              `)}
              <h5 class="mb-1">${avatar => avatar.name}</h5>
              ${(0, fast_element_1.when)(avatar => avatar.model, (0, fast_element_1.html) `<span class="badge badge-info">${avatar => avatar.model.model.label}</span>`)}
              ${(0, fast_element_1.when)(avatar => avatar.onboardingAvatar, (0, fast_element_1.html) `<div class="mt-1"><span class="badge badge-warning">${avatar => avatar.onboardingAvatar.profession.name}</span></div>`)}
              ${(0, fast_element_1.when)(avatar => avatar.description, (0, fast_element_1.html) `
              <div class="mt-2">
                <small class="text-muted">${avatar => avatar.description}</small>
              </div>
              `)}
              ${(0, fast_element_1.when)(avatar => avatar.gender, (0, fast_element_1.html) `
              <div class="mt-2">
                <small class="text-muted">
                  ${avatar => avatar.gender === 'male' ? (0, fast_element_1.html) `<i class="simple-icon-symbol-male"></i>
                  ${'gender.male'.t()}` : ''}
                  ${avatar => avatar.gender === 'female' ? (0, fast_element_1.html) `<i class="simple-icon-symbol-female"></i>
                  ${'gender.female'.t()}` : ''}
                </small>
              </div>
              `)}
              ${(0, fast_element_1.when)(avatar => avatar.processing, (0, fast_element_1.html) `
              <div class="mt-2">
                <span class="badge badge-info">${'avatar.processing.is_processing'.t()}</span>
              </div>
              `, (0, fast_element_1.html) `
              <div class="mt-2">
                <span class="badge badge-success">${'avatar.processing.done'.t()}</span>
              </div>
              `)}
            </div>
            <div class="">
              
              <div class="mb-3">


                
                <div class="d-flex justify-content-center">

                  <rws-tooltip side="top" text="${'avatar.tooltips.talk'.t()}">
                    <button @click="${(avatar, c) => c.parent.talkToAvatar(avatar.id)}"
                      class="btn btn-sm btn-secondary mr-1">
                      <i class="simple-icon-bubbles"></i>
                    </button>
                  </rws-tooltip>
                  <rws-tooltip side="top" text="${'avatar.tooltips.preview'.t()}">
                    <button @click="${(avatar, c) => c.parent.previewAvatar(avatar.id)}"
                      class="btn btn-sm btn-info mr-1">
                      <i class="simple-icon-magnifier"></i>
                    </button>
                  </rws-tooltip>
                  <rws-tooltip side="top" text="${'crud.edit'.t()}">
                    <button @click="${(avatar, c) => c.parent.editAvatar(avatar.id)}"
                      class="btn btn-sm btn-primary mr-1">
                      <i class="simple-icon-pencil"></i>
                    </button>
                  </rws-tooltip>
                  <rws-tooltip side="top" text="${'crud.delete'.t()}">
                    <button @click="${(avatar, c) => c.parent.deleteAvatar(avatar)}" class="btn btn-sm btn-danger">
                      <i class="simple-icon-trash"></i>
                    </button>
                  </rws-tooltip>
                  <knowledge-picker class="ml-1 mt-1"
                    :selectedIds="${(avatar, c) => c.parent.getAvatarKnowledgeIds(avatar.id)}"
                    @selectionChanged="${(avatar, c) => c.parent.onKnowledgeSelectionChanged(avatar.id, c.event.detail)}"
                    absolute="true" showCheckbox="true">
                  </knowledge-picker>
                </div>
              </div>
            </div>
          </div>
          `)}
        </div>
        `)}
      </div>
      
      
      ${(0, fast_element_1.when)(x => !x.loading && x.totalGridPages > 1, (0, fast_element_1.html) `
      <div class="mt-4">
        <app-pagination 
          :currentPage="${x => x.currentGridPage}" 
          :totalPages="${x => x.totalGridPages}"
          :perPage="${x => x.gridPerPage}" 
          :totalItems="${x => x.totalGridItems}"
          :onPageChange="${(x, c) => x.handleGridPageChanged.bind(x)}">
        </app-pagination>
      </div>      
      `)}
    </div>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.avatar-list-page img {
  object-fit: cover;
  border: 2px solid #dee2e6;
  transition: transform 0.2s ease;
}
.avatar-list-page img:hover {
  transform: scale(1.05);
}
.avatar-list-page knowledge-picker {
  position: relative;
  z-index: 1000;
}

.grid-switch button {
  height: 40px;
}`;
const shadowOptions = { "mode": "open" };
let AvatarList = class AvatarList extends client_1.RWSViewComponent {
    constructor(storageService, wsService, popupService, accountLimitService, signalService) {
        super();
        this.storageService = storageService;
        this.wsService = wsService;
        this.popupService = popupService;
        this.accountLimitService = accountLimitService;
        this.signalService = signalService;
        this.isList = false;
        this.canAdd = false;
        this.limitReached = false;
        this.limitTooltip = '';
        this.avatars = [];
        this.title = 'avatar.listTitle';
        this.addText = 'avatar.addAvatar';
        this.loading = false;
        // Grid pagination properties
        this.currentGridPage = 1;
        this.totalGridPages = 1;
        this.gridPerPage = 12;
        this.totalGridItems = 0;
        this.baseActions = [
            {
                key: 'talk',
                icon: 'simple-icon-bubbles',
                label: '',
                variant: 'secondary',
                tooltip: 'avatar.tooltips.talk'.t(),
                tooltipDirection: 'left',
                handler: async (id) => {
                    this.talkToAvatar.bind(this)(id);
                }
            },
            {
                key: 'preview',
                icon: 'simple-icon-magnifier',
                label: '',
                variant: 'info',
                tooltip: 'avatar.tooltips.preview'.t(),
                tooltipDirection: 'left',
                handler: async (id) => {
                    this.previewAvatar.bind(this)(id);
                }
            }
        ];
        this.tableColumns = [
            {
                key: 'id',
                header: 'ID',
            },
            {
                key: 'logo',
                header: 'avatar.image'.t(),
                formatter: (image) => {
                    let src = image || '/assets/images/avatar.jpg';
                    if (image) {
                        src = ('/uploads/' + image.filename).thumb('square-mini');
                    }
                    return `<img src="${src}" alt="Avatar" width="48" height="48" style="border-radius:50%" />`;
                }
            },
            {
                key: 'name',
                header: 'avatar.name'.t(),
                formatter: (name, row) => {
                    let html = `<div><strong>${name}</strong>`;
                    if (row.onboardingAvatar && row.onboardingAvatar.profession) {
                        html += `<br><span class="badge badge-secondary badge-sm mt-1">${row.onboardingAvatar.profession.name}</span>`;
                    }
                    html += '</div>';
                    return html;
                }
            },
            {
                key: 'gender',
                header: 'avatar.gender'.t(),
                formatter: (gender) => {
                    if (!gender)
                        return '-';
                    switch (gender) {
                        case 'male': return '<i class="simple-icon-symbol-male"></i> Mężczyzna';
                        case 'female': return '<i class="simple-icon-symbol-female"></i> Kobieta';
                        default: return gender;
                    }
                }
            },
            {
                key: 'age',
                header: 'avatar.age'.t(),
                formatter: (age) => age || '-'
            },
            {
                key: 'model',
                header: 'avatar.model'.t(),
                formatter: (model) => model ? model.model.label : '-'
            },
            {
                key: 'processing',
                header: 'avatar.processing'.t(),
                formatter: (processing) => processing ? `<span class="badge badge-info">${'avatar.processing.is_processing'.t()}</span>` : `<span class="badge badge-success">${'avatar.processing.done'.t()}</span>`
            },
            {
                key: 'active',
                header: 'resource.active'.t(),
                formatter: (active) => `<span class="badge badge-${active || active === null || active === undefined ? 'success' : 'danger'}">${active || active === null || active === undefined ? 'common.active'.t() : 'common.inactive'.t()}</span>`
            }
        ];
        this.statusListenerCallBacks = [];
        this.avatarData = [];
    }
    async connectedCallback() {
        var _a, _b, _c;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        const isParentUser = ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
        this.canAdd = component_2.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.avatar}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        if (!isSuperAdmin) {
            this.isAvatarUneditable = (key, row) => {
                return row.common === true && !(['talk', 'preview'].includes(key));
            };
            this.forceAvatarEditable = (key, row) => {
                var _a;
                // console.log({label})
                if (key === 'talk') {
                }
                if (!row.creator) {
                    return false;
                }
                return row.creator.id === ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.id);
            };
        }
        if (isSuperAdmin) {
            this.tableColumns.push({
                key: 'common',
                header: 'avatar.common'.t(),
                formatter: (common) => common ? `<span class="badge badge-info">${'common.common'.t()}</span>` : '-'
            });
        }
        if (isParentUser || isSuperAdmin) {
            this.tableColumns.push({
                key: 'removed',
                header: 'app.removed'.t(),
                formatter: (removed) => removed ? `<span class="badge badge-danger">${'app.removed'.t()}</span>` : '-'
            });
            this.tableColumns.push({
                key: 'creator',
                header: 'avatar.creator'.t(),
                formatter: (creator) => creator ? `<a class="creator-link" data-id="${creator.id}" href="/user/list/${creator.id}">${creator.name}</a>` : '-'
            });
        }
        this.on('crud-table:data-loaded', (event) => {
            this.avatarData = event.detail;
        });
        // Listen for deletions to refresh account limits for grid view
        this.on('crud-table:item-deleted', async (event) => {
            await this.checkAccountLimits();
        });
        super.connectedCallback();
        this.modelSignal = this.signalService.getSignal('selected_model', { initialValue: null });
        await this.checkAccountLimits();
        const savedGrid = this.storageService.get('avatar.grid');
        if (savedGrid) {
            this.isList = savedGrid === 'list';
        }
        // Load data for grid view
        if (!this.isList) {
            this.loadAvatarData();
        }
        if (this.wsService.isActive()) {
            this.statusListenerCallBacks.push(this.wsService.listenForMessage('status_update', (response) => {
                if (response.data.avatarId && response.data.status === 'ready' && this.avatarData.find(avatar => avatar.id === response.data.avatarId)) {
                    this.$('crud-table').loadData();
                }
            }));
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.statusListenerCallBacks.length) {
            this.statusListenerCallBacks.forEach(item => {
                item();
            });
            this.statusListenerCallBacks = [];
        }
    }
    navigateTo(path) {
        component_1.SiteMenu.goto.bind(this)(path);
    }
    onDataLoaded(data, totalPages, element) {
        if (data.length) {
            this.avatarData = data;
            setTimeout(() => {
                const badges = element.shadowRoot.querySelectorAll('span.onboard-badge');
                badges.forEach(badge => {
                    badge.style = 'cursor: pointer;';
                    badge.onclick = () => {
                        component_1.SiteMenu.goto.bind(this)(`/onboarding/wizard/${badge.dataset.id}`);
                    };
                });
                const creators = element.shadowRoot.querySelectorAll('a.creator-link');
                creators.forEach(creator => {
                    creator.onclick = (e) => {
                        e.preventDefault();
                        component_1.SiteMenu.goto.bind(this)(`/user/list/${creator.dataset.id}`);
                    };
                });
            }, 0);
        }
    }
    async talkToAvatar(id) {
        try {
            // Get the avatar data first to access its model and provider
            let avatar = this.avatarData.find(a => a.id === id);
            // If avatar doesn't have model data, fetch it from the API
            if (avatar && !avatar.model) {
                try {
                    const avatarResponse = await this.apiService.back.get('avatar.get', {
                        routeParams: { id: String(id) }
                    });
                    if (avatarResponse.success && avatarResponse.data) {
                        avatar = avatarResponse.data;
                    }
                }
                catch (error) {
                    console.error('Failed to fetch avatar data:', error);
                }
            }
            if (avatar && avatar.model) {
                // Set the model and provider information from the avatar
                this.storageService.set('ai.selectedAIProvider', avatar.model.aiProvider || 'inthub');
                this.storageService.set('ai.selectedProvider', JSON.stringify(avatar.model.provider));
                this.storageService.set('ai.selectedModel', JSON.stringify(avatar.model.model));
                this.storageService.set('ai.selectedAvatar', String(id));
            }
            else {
                // Fallback: just set avatar and let chat handle the rest
                this.storageService.set('ai.selectedAIProvider', 'inthub');
                this.storageService.set('ai.selectedAvatar', String(id));
                this.storageService.clear('ai.selectedModel');
                this.storageService.clear('ai.selectedProvider');
            }
            this.modelSignal.setValue({ ...avatar.model, avatar: String(id) });
            component_1.SiteMenu.goto.bind(this)(`/`);
        }
        catch (error) {
            console.error('Error setting avatar for chat:', error);
            // Fallback behavior
            this.storageService.set('ai.selectedAIProvider', 'inthub');
            this.storageService.set('ai.selectedAvatar', String(id));
            component_1.SiteMenu.goto.bind(this)(`/`);
        }
    }
    previewAvatar(id) {
        component_1.SiteMenu.goto.bind(this)(`/avatar/preview/${id}`);
    }
    toggleToList() {
        this.isList = true;
        this.storageService.set('avatar.grid', 'list');
    }
    toggleToGrid() {
        this.isList = false;
        this.storageService.set('avatar.grid', 'grid');
        this.loadAvatarData();
    }
    editAvatar(id) {
        this.navigateTo(`/avatar/form/${id}`);
    }
    async deleteAvatar(avatar) {
        if (!await this.popupService.confirm('crud.confirmDelete'.t() + ` ${backendImport_1.ACL.aclResources.avatar}?`)) {
            return false;
        }
        await this.apiService.back.delete(`avatar.delete`, { routeParams: { id: avatar.id.toString() } });
        // If this was the last item on the current page and we're not on page 1, go to previous page
        if (this.avatarData.length === 1 && this.currentGridPage > 1) {
            this.currentGridPage = Math.max(1, this.currentGridPage - 1);
        }
        this.loadAvatarData();
        this.signalService.getSignal('avatar_reload', { initialValue: false }).setValue(true);
    }
    getAvatarKnowledgeIds(avatarId) {
        const avatar = this.avatarData.find(a => a.id === avatarId);
        if (!avatar || !avatar.avatarKnowledge) {
            return '';
        }
        const knowledgeIds = avatar.avatarKnowledge.map(k => k.knowledge.id.toString());
        return knowledgeIds.join(',');
    }
    async onKnowledgeSelectionChanged(avatarId, detail) {
        // Save to backend
        await this.saveAvatarKnowledge(avatarId, detail.selectedIds);
    }
    async saveAvatarKnowledge(avatarId, knowledgeIds) {
        try {
            // First, get the current avatar data
            const avatarResponse = await this.apiService.back.get('avatar.get', {
                routeParams: { id: String(avatarId) }
            });
            if (!avatarResponse.success || !avatarResponse.data) {
                throw new Error('Failed to load avatar data');
            }
            const avatar = avatarResponse.data;
            // Prepare the update payload
            const updatePayload = {
                name: avatar.name,
                description: avatar.description,
                gender: avatar.gender,
                age: avatar.age,
                voice: avatar.voice || '',
                model: avatar.model,
                isVoiceAgent: avatar.isVoiceAgent || false,
                logo: avatar.logo,
                knowledgeIds: knowledgeIds,
                common: avatar.common || false,
                active: avatar.active !== undefined ? avatar.active : true
            };
            // Update the avatar
            const response = await this.apiService.back.put('avatar.update', updatePayload, {
                routeParams: { id: String(avatarId) }
            });
            if (response.success) {
                this.notifyService.notify('avatar.knowledge.updated'.t(), 'info');
            }
            else {
                this.notifyService.notify(response.error || 'avatar.knowledge.update.error'.t(), 'error');
            }
        }
        catch (e) {
            console.error('Failed to update avatar knowledge:', e);
            this.notifyService.notify('avatar.knowledge.update.error'.t(), 'error');
        }
    }
    async loadAvatarData() {
        if (this.isList)
            return; // Only load for grid view
        this.loading = true;
        try {
            // Use pagination to get all avatar data (active and inactive)
            const response = await this.apiService.back.get('avatar.list', {
                queryParams: {
                    p: this.currentGridPage.toString(),
                    per_page: this.gridPerPage.toString()
                }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.avatarData = response.data;
                this.totalGridItems = response.count || 0;
                this.totalGridPages = Math.max(1, Math.ceil(this.totalGridItems / this.gridPerPage));
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'crud.failedToLoad'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('crud.failedToLoad'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    handleGridPageChanged(page) {
        if (this.currentGridPage === page) {
            return; // Prevent duplicate calls
        }
        this.currentGridPage = page;
        this.loadAvatarData();
    }
    async checkAccountLimits() {
        const limitCheck = await this.accountLimitService.checkResourceLimitWithCount('avatar');
        this.limitReached = !limitCheck.canCreate;
        this.limitTooltip = limitCheck.message || '';
    }
};
exports.AvatarList = AvatarList;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], AvatarList.prototype, "isAvatarUneditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], AvatarList.prototype, "forceAvatarEditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarList.prototype, "isList", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarList.prototype, "canAdd", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarList.prototype, "limitReached", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AvatarList.prototype, "limitTooltip", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarList.prototype, "avatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AvatarList.prototype, "title", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AvatarList.prototype, "addText", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], AvatarList.prototype, "currentGridPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], AvatarList.prototype, "totalGridPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], AvatarList.prototype, "gridPerPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], AvatarList.prototype, "totalGridItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarList.prototype, "baseActions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarList.prototype, "tableColumns", void 0);
exports.AvatarList = AvatarList = __decorate([
    (0, client_1.RWSView)('avatar-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __param(2, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(3, (0, client_1.RWSInject)(AccountLimitService_1.default)),
    __param(4, (0, client_1.RWSInject)(SignalService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _b : Object, typeof (_c = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _c : Object, typeof (_d = typeof AccountLimitService_1.AccountLimitServiceInstance !== "undefined" && AccountLimitService_1.AccountLimitServiceInstance) === "function" ? _d : Object, typeof (_e = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _e : Object])
], AvatarList);
AvatarList.defineComponent();
